module.exports = __webpack_public_path__ + "img/myposition_wm_루이스 피구.98ddce63.png";